/**
 * 属性图模块引导：懒加载 klaiyi-option-images.css/js，快购属性图桥接。
 * 从 newklayi.js 抽离，避免主文件继续膨胀。
 */
(function ($) {
  if (!$) return;

  function getCfg() {
    return window.__KLAIYI_OPTION_IMAGES__ || {};
  }

  function stylesheetBasename(url) {
    if (!url) return "";
    try {
      var path = String(url).split(/[?#]/)[0];
      return path.substring(path.lastIndexOf("/") + 1);
    } catch (e) {
      return "";
    }
  }

  function isSameStylesheetHref(existingHref, targetHref) {
    if (!existingHref || !targetHref) return false;
    if (existingHref === targetHref) return true;
    // Shopify CDN 常带 ?v=；只认文件名恰好为 klaiyi-option-images.css，避免子串误匹配
    return stylesheetBasename(existingHref) === "klaiyi-option-images.css" &&
      stylesheetBasename(targetHref) === "klaiyi-option-images.css";
  }

  function ensureStylesheet(href) {
    if (!href) return;
    if (document.querySelector("link[data-klaiyi-option-images-css]")) return;
    try {
      var links = document.querySelectorAll('link[rel="stylesheet"], link[rel="preload"][as="style"]');
      for (var i = 0; i < links.length; i++) {
        var existingHref = links[i].href || links[i].getAttribute("href") || "";
        if (isSameStylesheetHref(existingHref, href)) {
          links[i].setAttribute("data-klaiyi-option-images-css", "");
          return;
        }
      }
    } catch (e) {}
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.setAttribute("data-klaiyi-option-images-css", "");
    document.head.appendChild(link);
  }

  window.ensureKlaiyiOptionImages = function ensureKlaiyiOptionImages() {
    var cfg = getCfg();
    var assets = cfg.assets || {};
    var cssHref = assets.css;
    var jsSrc = assets.js;

    ensureStylesheet(cssHref);

    if (typeof window.klaiyiApplyOptionImagesToQuickShop === "function") {
      return Promise.resolve();
    }

    if (!jsSrc) {
      return Promise.resolve();
    }

    if (window.__klaiyiOptionImagesLoadPromise) {
      return window.__klaiyiOptionImagesLoadPromise;
    }

    window.__klaiyiOptionImagesLoadPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-klaiyi-option-images-js]');
      if (existing) {
        existing.addEventListener("load", function () {
          resolve();
        });
        existing.addEventListener("error", reject);
        return;
      }

      var script = document.createElement("script");
      script.src = jsSrc;
      script.defer = true;
      script.setAttribute("data-klaiyi-option-images-js", "");
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__klaiyiOptionImagesLoadPromise;
  };

  function tagQuickShopTextOptionSwatches() {
    $(
      ".quick_shop ul.js-klaiyi-option-swatch-list:not(.SizeSwatchList--optionImages)"
    )
      .find("label.SizeSwatch:not(.SizeSwatch--withOptionImage)")
      .addClass("SizeSwatch--quickshop");
  }

  window.applyQuickShopOptionImagesThen = function applyQuickShopOptionImagesThen(
    productData,
    callback
  ) {
    var productId =
      $(".quick_shop form").attr("data-id") || (productData && productData.id);

    var finish = function () {
      tagQuickShopTextOptionSwatches();
      if (typeof callback === "function") {
        callback();
      }
      window.__quickShopSuppressOptionGallerySync = false;
      if (typeof window.scheduleQuickShopMobileLayoutRefresh === "function") {
        window.scheduleQuickShopMobileLayoutRefresh();
      }
    };

    var runGuideImages = function () {
      if (
        typeof window.klaiyiApplyGuideImagesToQuickShop === "function" &&
        productId
      ) {
        return Promise.resolve(
          window.klaiyiApplyGuideImagesToQuickShop(productId, productData)
        ).catch(function () {});
      }
      return Promise.resolve();
    };

    var runOptionImages = function () {
      var optionPromise =
        typeof window.klaiyiApplyOptionImagesToQuickShop === "function" &&
        productId
          ? Promise.resolve(
              window.klaiyiApplyOptionImagesToQuickShop(productId)
            ).catch(function () {})
          : Promise.resolve();

      Promise.all([optionPromise, runGuideImages()]).then(finish).catch(finish);
    };

    window.ensureKlaiyiOptionImages()
      .then(runOptionImages)
      .catch(runOptionImages);
  };

  function scheduleDetailPrefetch() {
    var cfg = getCfg();
    if (!cfg.productId) return;

    var assetsScheduled = false;
    var run = function () {
      if (assetsScheduled) return;
      assetsScheduled = true;
      window.ensureKlaiyiOptionImages();
    };

    if (cfg.eagerOnProduct) {
      if (typeof window.klaiyiScheduleProductOptionImagesFetch === "function") {
        window.klaiyiScheduleProductOptionImagesFetch();
      }
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", run);
      } else {
        run();
      }
      return;
    }

    var runWithFetch = function () {
      if (typeof window.klaiyiStartOptionImagesFetch === "function") {
        window.klaiyiStartOptionImagesFetch(false);
      }
      run();
    };

    document.documentElement.addEventListener(
      "klaiyi:option-images-ready",
      function onDataReady() {
        run();
      }
    );

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        function () {
          setTimeout(runWithFetch, 200);
        },
        { once: true }
      );
    } else {
      setTimeout(runWithFetch, 200);
    }
  }

  function scheduleListingPrefetch() {
    var run = function () {
      window.ensureKlaiyiOptionImages();
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(run, { timeout: 5000 });
    } else {
      window.addEventListener("load", function () {
        setTimeout(run, 1500);
      });
    }
  }

  $(function () {
    var cfg = getCfg();
    if (cfg.productId) {
      scheduleDetailPrefetch();
    } else if (cfg.prefetchOnIdle) {
      scheduleListingPrefetch();
    }
  });
})(window.jQuery || window.theme?.jQuery);
